/* JYM gallery sync — select the variant's featured media by media id, not by Shopify's `position`.
   Impact scrolls to `featured_media.position - 1`, which assumes positions are contiguous. On products where a
   media slot is missing (Pre JYM skips position 20), every later flavor lands one slide late. We resolve the
   carousel index from data-media-id instead. Decision record: docs/pdp-redesign/PLAN.md */
(function () {
  function sync(mediaId) {
    if (!mediaId) return;
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('media-carousel').forEach(function (carousel) {
      var items = Array.prototype.slice.call(carousel.querySelectorAll('.product-gallery__media'));
      var index = items.findIndex(function (el) { return el.getAttribute('data-media-id') === String(mediaId); });
      if (index < 0 || typeof carousel.select !== 'function') return;
      if (carousel.selectedIndex !== index) carousel.select(index, { animate: false, force: true });
    });
  }

  document.addEventListener('variant:change', function (event) {
    var v = event.detail && event.detail.variant;
    if (v && v.featured_media && v.featured_media.id) {
      // run after Impact's own (position-based) handler so ours is the final word
      setTimeout(function () { sync(v.featured_media.id); }, 0);
    }
  });

  // Initial load: Impact's initial-index is position-based too. The gallery carries the intended media id.
  function initial() {
    var gallery = document.querySelector('product-gallery[data-jym-initial-media]');
    if (gallery) sync(gallery.getAttribute('data-jym-initial-media'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initial); else initial();
  window.addEventListener('load', initial);
})();
